import store from '@/store'
import axios from 'axios'

export default {
  async removeAddress (id) {
    try {
      let result = await axios.delete(store.getters.getOpaApi + `/company/adresses/${store.state.company.Id}/${id}`)
      return result.data
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error:true, data: error.e}
    }
  },

  async saveAddress (address) {
    try {
      // remove before save, address has not update
      if (address.id) {
        await this.removeAddress(address.id)
      }
      let result = await axios.post(store.getters.getOpaApi + `/company/adresses/${store.state.company.Id}`, address)
      if (result.data) {
        return result.data
      } else {
        return { error:true }
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return { error:true, data: error.e }
    }
  },

  async removePinAddress (id) {
    try {
      let result = await axios.delete(store.getters.getOpaApi + `/company/pinAdress/${store.state.company.Id}/${id}`)
      return result.data
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error:true, data: error.e}
    }
  },

  async savePinAddress (pinAddress) {
    try {
      // remove before save, address has not update
      if (pinAddress.id) {
        await this.removeAddress(pinAddress.id)
      }
      let result = await axios.post(store.getters.getOpaApi + `/company/pinAdress/${store.state.company.Id}/${pinAddress.lat}/${pinAddress.lng}/${pinAddress.retrieve}`, {
        address: pinAddress.address
      })
      if (result.data) {
        return result.data
      } else {
        return { error:true }
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return { error:true, data: error.e }
    }
  }
}